import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, ImageOff } from "lucide-react";
import { fileUrl } from "../lib/api";

export const PhotoSlider = ({ photos = [], interval = 3000, arrows = false, className = "aspect-square", testId = "photo-slider" }) => {
  const [idx, setIdx] = useState(0);
  const n = photos.length;

  useEffect(() => {
    if (n < 2) return undefined;
    const id = setInterval(() => setIdx((i) => (i + 1) % n), interval);
    return () => clearInterval(id);
  }, [n, interval]);

  useEffect(() => {
    if (idx >= n) setIdx(0);
  }, [n, idx]);

  if (!n) {
    return (
      <div className={`${className} grid place-items-center bg-slate-100 text-slate-300`} data-testid={testId}>
        <ImageOff className="h-8 w-8" />
      </div>
    );
  }

  const go = (e, d) => {
    e.stopPropagation();
    setIdx((i) => (i + d + n) % n);
  };

  return (
    <div className={`${className} relative overflow-hidden bg-slate-100`} data-testid={testId}>
      {photos.map((p, i) => (
        <img key={p + i} src={fileUrl(p)} alt="" loading="lazy"
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0"}`} />
      ))}
      {arrows && n > 1 && (
        <>
          <button type="button" onClick={(e) => go(e, -1)} data-testid={`${testId}-prev`}
            className="absolute left-2 top-1/2 -translate-y-1/2 grid h-8 w-8 place-items-center rounded-full bg-white/90 shadow hover:bg-white">
            <ChevronLeft className="h-4 w-4" />
          </button>
          <button type="button" onClick={(e) => go(e, 1)} data-testid={`${testId}-next`}
            className="absolute right-2 top-1/2 -translate-y-1/2 grid h-8 w-8 place-items-center rounded-full bg-white/90 shadow hover:bg-white">
            <ChevronRight className="h-4 w-4" />
          </button>
        </>
      )}
      {n > 1 && (
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
          {photos.map((_, i) => (
            <span key={i} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-4 bg-white" : "w-1.5 bg-white/60"}`} />
          ))}
        </div>
      )}
    </div>
  );
};
